import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import API from "api";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
// import Questions from "./Questions";
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const TestHeader = forwardRef(({ mockData, setMockData, id, routeState,
  soundArr,
  timerRef , finalObjectCreation, finalSubmit}, ref) => {
  const intStatus = useSelector((state) => state.intStatus);
  const [time, setTime] = useState(mockData.secondCount);
  const [qTime, setQTime] = useState(mockData.qTime);
  const currentQuestion = mockData.currentQuestion;
  const totalTime = mockData.secondCount;
  const tempRef = useRef(time);
  const mockRef = useRef(mockData);
  const hasSubmittedRef = useRef(false);
  const [, forceUpdate] = useState();
  useEffect(() => {
    setTime(totalTime);
  }, [totalTime]);

  useEffect(() => {
    setQTime(0);
  }, [currentQuestion]);

const timer = useCallback(() => {
  let connection;
  if (typeof intStatus === undefined || typeof intStatus === "undefined") {
    connection = true;
  } else {
    connection = intStatus;
  }

  if (connection) {
    if (!mockRef.current.internet) {
      setMockData((prevState) => {
        return { ...prevState, internet: true };
      });
    }

    if (Number(Math.round(tempRef.current.toFixed(1))) === 0) {
      let intervalId;
      setMockData((prevState) => {
        intervalId = prevState.intervalId;
        return {
          ...prevState,
          dashboardFlag: true,
          timeOutFlag: true,
          timeOut: true,
          stopRecording: true,
          pending: 1,
          nextType: 1,
          complete: 1,
          secondCount: tempRef.current,
          qTime,
        };
      });
// tempRef.current === 0 ? tempRef.current  : tempRef.current,
      // Auto-submit current question when time runs out - ONLY ONCE
    //   if (finalObjectCreation && finalSubmit && !hasSubmittedRef.current) {
    //     hasSubmittedRef.current = true; // Prevent multiple calls
        
    //     let obj1 = finalObjectCreation();
    //     finalSubmit(obj1).then((res) => {
    //       console.log("res", res);
    //         // Check if the response indicates success
    // // This handles multiple possible response formats
    // const isSuccess = 
    //   res?.status === 200 || 
    //   res?.statusCode === 200 || 
    //   res?.data?.status === 200 ||
    //   res?.success === true ||
    //   (res && !res.error);
    //   console.log("isSuccess==",isSuccess);
    //   console.log("response===",res);
      
      
    
    // if (!isSuccess) {
    //   throw new Error("Submission failed");
    // }
    
    //       // Call second API after first one succeeds
    //       let bodyFormData = new FormData();
    //       bodyFormData.append("mock_id", id);

    //       mockRef.current.ids.map((v, k) => {
    //         if (k !== 0) {
    //           bodyFormData.append("id[]", `${v.id}-${v.question_number}`);
    //         }
    //       });

    //       API({
    //         method: "Post",
    //         url: "set/mockTime",
    //         data: bodyFormData,
    //       });
    //     }).catch((error) => {
    //       console.error("Error submitting:", error);
    //       // Optionally reset flag on error if you want to retry
    //       // hasSubmittedRef.current = false;
    //     });
    //   }
    // Auto-submit current question when time runs out - ONLY ONCE
// Auto-submit current question when time runs out - ONLY ONCE
if (finalObjectCreation && finalSubmit && !hasSubmittedRef.current) {
  console.log("=== Starting submission process ===");
  hasSubmittedRef.current = true;
  clearInterval(intervalId); // Stop timer immediately
  
  try {
    let obj1 = finalObjectCreation();
    console.log("obj1 created:", obj1);
    
    const submitResult = finalSubmit(obj1);
    console.log("finalSubmit called, result:", submitResult);
    
    Promise.resolve(submitResult)
      .then((res) => {
        console.log("=== Got response from finalSubmit ===");
        console.log("response-----------", res);
        
        // Check response status
        const isSuccess = 
          res?.status === 200 || 
          res?.statusCode === 200 || 
          res?.data?.status === 200 ||
          res?.success === true;
        
        console.log("Is success:", isSuccess);
        
        if (!isSuccess) {
          console.error("First submission failed:", res);
          throw new Error("Submission failed");
        }
        
        // Call second API after first one succeeds
        console.log("=== Preparing to call set/mockTime ===");
        let bodyFormData = new FormData();
        bodyFormData.append("mock_id", id);

        mockRef.current.ids.forEach((v, k) => {
          if (k !== 0) {
            bodyFormData.append("id[]", `${v.id}-${v.question_number}`);
          }
        });
        
        console.log("Calling set/mockTime API...");

        return API({
          method: "Post",
          url: "set/mockTime",
          data: bodyFormData,
        });
      })
      .then((secondRes) => {
        console.log("=== Mock time set successfully ===", secondRes);
      })
      .catch((error) => {
        console.error("=== Error in submission process ===", error);
        console.error("Error stack:", error.stack);
        hasSubmittedRef.current = false;
      });
  } catch (error) {
    console.error("=== Caught synchronous error ===", error);
    hasSubmittedRef.current = false;
  }
} else {
  console.log("Submission conditions not met:", {
    hasFinalObjectCreation: !!finalObjectCreation,
    hasFinalSubmit: !!finalSubmit,
    alreadySubmitted: hasSubmittedRef.current
  });
}
      
      clearInterval(intervalId);
      return;
    }
    setTime((prevState) => {
      tempRef.current = prevState - 1;
      return prevState - 1;
    });
    setQTime((prevState) => prevState + 1);
  } else {
    if (mockRef.current.internet) {
      setMockData((prevState) => {
        return { ...prevState, internet: false };
      });
    }
  }
}, [mockRef, intStatus]);

  useEffect(() => {
    let intervalId = setInterval(timer, 1000);
    setMockData((prevState) => {
      return { ...prevState, intervalId };
    });

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

  useEffect(() => {
    mockRef.current = mockData;
  }, [mockData]);

  const callbackHandler = () => {
    return {
      timerData() {
        return { qTime, time };
      },
    };
  };

  useImperativeHandle(ref, callbackHandler);

  return (
    // <CardHeader>
    <Row className="m-0 test_width">
      {/* <Col xs={6}>
          <Card.Title tag="h4">{mockData.title}</Card.Title>
        </Col>
        <Col xs={6}>
          <div className="text-right questionTime">
            <div className="timeRemaining">
              <p>
                <i className="fa fa-clock-o"></i>{" "}
                <span>
                  Time Remaining:{" "}
                  {Math.floor(time / 60) + ":" + parseInt(time % 60)}
                </span>
              </p>
            </div>
            <div className="item">
              <p>
                Question {mockData.currentQuestion + mockData.qCount + 1} of{" "}
                {mockData.questionData.length + mockData.qCount}
              </p>
            </div>
          </div>
        </Col> */}
      {/* <Col xs={12}> */}
      {/* <Card style={{ backgroundColor: "transparent" }}> */}
      {/* <CardHeader style={{ padding: "20px 40px 0px" }}> */}
      {/* <Row className="d-none align-items-end flex-column gap-3 rounded-2 p-3 m-0">
        <Row className="d-flex justify-content-between">
          <Col style={{ width: "fit-content", padding: "0" }}>
            <Card.Title tag="h4">{mockData.title}</Card.Title>
          </Col>
          <Col style={{ width: "fit-content" }}>
            <div className="text-right questionTime">
              <div className="timeRemaining time-spent">
                <p>
                  <i className="fa fa-clock-o"></i>{" "}
                  <span>
                    {" "}
                    Time Remaining:{" "}
                    {Math.floor(time / 60) + ":" + parseInt(time % 60)}
                  </span>
                </p>
              </div>
              <div className="item">
                <p>
                  {" "}
                  Question {mockData.currentQuestion +
                    mockData.qCount +
                    1} of {mockData.questionData.length + mockData.qCount}
                </p>
              </div>
            </div>
          </Col>
        </Row> */}
        {/* <Row style={{ borderRadius: "18px" }} className="time-spent">
                  <p>{title}</p>
                </Row> */}
      {/* </Row> */}
      <Row
        className="d-flex justify-content-between align-items-center w-100 mock-header-bg h-50"
        style={{
          height: "40px	!important",
        }}
      >
        <Col
          style={{
            width: "fit-content",
            padding: "0",
          }}
        >
          <Card.Title tag="h4" className="m-0 mx-2">
            Language Academy - {mockData.title}
          </Card.Title>
        </Col>
        {/* time-spent */}
        <Col style={{ width: "fit-content" }}>
          <div className="text-right questionTime p-2">
            <div className="timeRemaining">
              <p>
                <i className="fa fa-clock-o"></i>
                <span>
                  Time Remaining:
                  {Math.floor(time / 60) + ":" + parseInt(time % 60)}
                </span>
              </p>
            </div>
            <div className="item">
              <p>
                Question {mockData.currentQuestion + mockData.qCount + 1} of{" "}
                {mockData.questionData.length + mockData.qCount}
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        style={{
          backgroundColor: "#0081A4",
          minHeight: "40px",
        }}
        className="d-flex justify-content-end align-items-center px-4"
      >
        <div className="d-flex justify-content-end gap-3">
          {/* <i className="fa-solid fa-up-right-and-down-left-from-center text-white fs-5"></i> */}
          {/* <i className="fa-solid fa-moon text-white fs-5"></i> */}
              <img
                src={isFullScreen() ? ExitFullScreen : FullScreen}
                onClick={() => {
                toggleFullScreen();
                setTimeout(() => {
									forceUpdate({});
								}, 100);
                }}
                alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
                className="toggle-icons"
              />
              <img
                src={isDarkMode() ? LightMode : DarkMode}
                onClick={() => {
                toggleTheme();
                forceUpdate({});
                }}
                alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
                className="toggle-icons"
              />		
        </div>
      </Row>
      {/* </CardHeader> */}
      {/* <CardBody>
              <Row className='unselectable'>
                {this.state.secondCount === 0 && <div>Time up please restart the Test</div>}
                {
                  this.state.internet
                    ? this.state.secondCount !== 0
                    && this.state.questionData && !this.state.loading && que
                    : <>
                      <Skeleton count={1} width={"50%"} height={200} containerClassName="skeleton-wrapper__mockrecording" />
                      <Skeleton count={5} width={"100%"} containerClassName="skeleton-wrapper__mocklines" />
                    </>
                }
              </Row>
            </CardBody> */}
      {/* </Card> */}
      {/* </Col> */}
      {/* <Questions
        mockData={mockData}
        setMockData={setMockData}
        routeState={routeState}
        soundArr={soundArr}
        timerRef={timerRef}
      /> */}
    </Row>
    // </CardHeader>
  );
});

export default TestHeader;
